/* Initialize Judge.me badges added by pagination, filters and recommendations. */
(() => {
  const selector = '.jdgm-preview-badge:not(.jdgm--done-setup)';
  let scheduled = false;

  const refresh = () => {
    scheduled = false;
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      window.jdgm.customizeBadges();
    }
  };

  const observer = new MutationObserver((records) => {
    const hasNewBadge = records.some((record) =>
      Array.from(record.addedNodes).some((node) =>
        node.nodeType === 1 &&
        (node.matches(selector) || node.querySelector(selector))
      )
    );
    if (hasNewBadge && !scheduled) {
      scheduled = true;
      window.setTimeout(refresh, 50);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  refresh();
})();
